import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"

// const debug = "FieldTaskSystemStatus_ViewGroup"
const debug = false

export default function FieldTaskSystemStatus_ViewGroup(props: FieldViewGroupProps) {

    const value             = props.field.getViewValue(props.model)

    const systemStatusColor = gd.const.systemStatusColor[value]
    // const systemStatusName  = gd.const.systemStatusList[value]

    const classes       = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)
    const iconClasses   = Classes('size-13 border-radius-4 status-color-'+systemStatusColor)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <div className={iconClasses}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy)}</div>
        </div>
    )
}



